import { configProps } from "../../types";

export const productsConfig: configProps<"products"> = {
  view: "products",
  title: "Towary",
  columns: [
    {
      id: 1,
      field: "name",
      header: "Nazwa",
      isDefaultVisible: true,
      className: "column--small",
      inputType: "text",
      required: true,
      sortable: true,
    },
    {
      id: 2,
      field: "sales_contract_template_id",
      header: "Szablon umowy sprzedaży",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "dropdown",
      optionsKey: "contractTemplates",
      required: false,
      sortable: false,
      body: (rowData) => rowData.sales_contract_template?.name || "",
    },
    {
      id: 3,
      field: "purchase_contract_template_id",
      header: "Szablon umowy zakupu",
      isDefaultVisible: true,
      className: "column--medium",
      inputType: "dropdown",
      optionsKey: "contractTemplates",
      required: false,
      sortable: false,
      body: (rowData) => rowData.purchase_contract_template?.name || "",
    },
  ],
};
